import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import GUI from 'lil-gui'
import { RectAreaLightHelper } from 'three/examples/jsm/Addons.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

function HumanModelLogic ({handleSelectedSection, handleHovered}) {
/**
 * Base
 */
// Debug
// const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()


/**
 * Lights
 */

const ambientLight = new THREE.AmbientLight(0xffffff, 1)
scene.add(ambientLight)

// Directional Light

// FRONT
const directionalLightFront = new THREE.DirectionalLight(0xffffff, 1)
directionalLightFront.position.set(0, - 1, 1)

// BACK
const directionalLightBack = new THREE.DirectionalLight(0xffffff, 1)
directionalLightBack.position.set(0, - 1, - 1)
scene.add(directionalLightFront, directionalLightBack)

// const directionalLightFrontHelper = new THREE.DirectionalLightHelper(directionalLightFront, 0.2)
// const directionalLightBackHelper = new THREE.DirectionalLightHelper(directionalLightBack, 0.2)
// scene.add(directionalLightFrontHelper, directionalLightBackHelper)


// LUCE SPALLA SX
const luceSpallaSxCenter = new THREE.SpotLight(0xff0000, 40, 0.5, Math.PI * 0.1, 0.1, 0.02)
luceSpallaSxCenter.position.set(0.6, 1.1, - 0.14)
luceSpallaSxCenter.target.position.x = - 0.85
// scene.add(luceSpallaSxCenter.target)
// scene.add(luceSpallaSxCenter)

const luceSpallaSxFront = new THREE.SpotLight(0xff0000, 50, 0.5, Math.PI * 0.1, 0.1, 0.8)
luceSpallaSxFront.position.set(0.20, 1.04, 0.28)
// luceSpallaSxFront.target.position.x = - 0.75
luceSpallaSxFront.target.position.z = - 0.50
luceSpallaSxFront.target.position.y =  0.5
luceSpallaSxFront.target.position.x =  + 0.2
// scene.add(luceSpallaSxFront.target)
// scene.add(luceSpallaSxFront)

const luceSpallaSxBack = new THREE.SpotLight(0xff0000, 30, 0.5, Math.PI * 0.1, 0.1, 1)
luceSpallaSxBack.position.set(0.28, 0.85, - 0.6)
// luceSpallaSxBack.target.position.x = - 0.75
luceSpallaSxBack.target.position.z = 0.75
luceSpallaSxBack.target.position.y =  0.6
// scene.add(luceSpallaSxBack.target)
// scene.add(luceSpallaSxBack)


const luceSpallaSxCenterHelper = new THREE.SpotLightHelper(luceSpallaSxCenter)
const luceSpallaSxBackHelper = new THREE.SpotLightHelper(luceSpallaSxBack)
const luceSpallaSxFrontHelper = new THREE.SpotLightHelper(luceSpallaSxFront)
// scene.add( luceSpallaSxBackHelper, luceSpallaSxCenterHelper, luceSpallaSxFrontHelper)


// LUCE SPALLA DX
const luceSpallaDxCenter = new THREE.SpotLight(0xff0000, 40, 0.5, Math.PI * 0.1, 0.1, 0.02)
luceSpallaDxCenter.position.set(-0.60, 1.1, - 0.14)
luceSpallaDxCenter.target.position.x =  0.90
// scene.add(luceSpallaDxCenter.target)
// scene.add(luceSpallaDxCenter)

const luceSpallaDxFront = new THREE.SpotLight(0xff0000, 50, 0.5, Math.PI * 0.1, 0.1, 0.8)
luceSpallaDxFront.position.set(-0.25, 1.04, 0.28)
// luceSpallaDxFront.target.position.x = - 0.75
luceSpallaDxFront.target.position.z = - 0.50
luceSpallaDxFront.target.position.y =  0.5
luceSpallaDxFront.target.position.x =  - 0.1
// scene.add(luceSpallaDxFront.target)
// scene.add(luceSpallaDxFront)

const luceSpallaDxBack = new THREE.SpotLight(0xff0000, 30, 0.5, Math.PI * 0.1, 0.1, 1)
luceSpallaDxBack.position.set(-0.28, 0.85, - 0.6)
// luceSpallaDxBack.target.position.x = - 0.75
luceSpallaDxBack.target.position.z = 0.75
luceSpallaDxBack.target.position.y =  0.6
// scene.add(luceSpallaDxBack.target)
// scene.add(luceSpallaDxBack)


const luceSpallaDxCenterHelper = new THREE.SpotLightHelper(luceSpallaDxCenter)
const luceSpallaDxBackHelper = new THREE.SpotLightHelper(luceSpallaDxBack)
const luceSpallaDxFrontHelper = new THREE.SpotLightHelper(luceSpallaDxFront)
// scene.add( luceSpallaDxCenterHelper, luceSpallaDxBackHelper, luceSpallaDxFrontHelper)


// LUCE TESTA/COLLO

// FRONT

const luceTestaColloFront = new THREE.SpotLight(0xff0000, 50, 0.5, Math.PI * 0.1, 0.1, 2)
luceTestaColloFront.position.set(-0.05, 1.06, 0.56)
// luceTestaColloFront.target.position.x = - 0.75
// luceTestaColloFront.target.position.x =  + 0.2
luceTestaColloFront.target.position.z = - 0.50
luceTestaColloFront.target.position.y = 1.05
// scene.add(luceTestaColloFront.target)
const luceTestaColloFrontHelper = new THREE.SpotLightHelper(luceTestaColloFront)
// scene.add( luceTestaColloFrontHelper)


// const luceTestaColloFront = new THREE.PointLight(0xff0000, 0.3, 15, 2)
// luceTestaColloFront.position.set(0, 1.1, 0.2)


// BACK

const luceTestaColloBack = new THREE.SpotLight(0xff0000, 50, 0.5, Math.PI * 0.1, 0.1, 2)
luceTestaColloBack.position.set(-0.05, 1.06, - 0.56)
// luceTestaColloBack.target.position.x = - 0.75
luceTestaColloBack.target.position.x =  - 0.045
luceTestaColloBack.target.position.z = - 0.50
luceTestaColloBack.target.position.y = 1.066
// scene.add(luceTestaColloBack.target)
const luceTestaColloBackHelper = new THREE.SpotLightHelper(luceTestaColloBack)
// scene.add( luceTestaColloBackHelper)
// const luceTestaColloBack = new THREE.PointLight(0xff0000, 0.3, 15, 2)
// luceTestaColloBack.position.set(0, 1.1, - 0.2)


// LEFT

const luceTestaColloLeft = new THREE.SpotLight(0xff0000, 50, 0.5, Math.PI * 0.1, 0.1, 2)
luceTestaColloLeft.position.set(-0.5, 1.06, 0)
// luceTestaColloLeft.target.position.x = - 0.75
luceTestaColloLeft.target.position.x =  - 0.047
luceTestaColloLeft.target.position.z = 0
luceTestaColloLeft.target.position.y = 1.08
// scene.add(luceTestaColloLeft.target)
const luceTestaColloLeftHelper = new THREE.SpotLightHelper(luceTestaColloLeft)
// scene.add( luceTestaColloLeftHelper)
// const luceTestaColloLeft = new THREE.PointLight(0xff0000, 0.3, 15, 2)
// luceTestaColloLeft.position.set(- 0.2, 1.1, 0)

// RIGHT
const luceTestaColloRight = new THREE.SpotLight(0xff0000, 50, 0.5, Math.PI * 0.1, 0.1, 2)
luceTestaColloRight.position.set(0.5, 1.06, 0)
// luceTestaColloRight.target.position.x = - 0.75
luceTestaColloRight.target.position.x =   0.047
luceTestaColloRight.target.position.z = 0
luceTestaColloRight.target.position.y = 1.08
// scene.add(luceTestaColloRight.target)
const luceTestaColloRightHelper = new THREE.SpotLightHelper(luceTestaColloRight)
// scene.add( luceTestaColloRightHelper)

// const luceTestaColloRight = new THREE.PointLight(0xff0000, 0.3, 15, 2)
// luceTestaColloRight.position.set(0.2, 1.1, 0)

// TOP

const luceTestaColloTop = new THREE.SpotLight(0xff0000, 50, 0.5, Math.PI * 0.1, 0.1, 2)
luceTestaColloTop.position.set(0, 1.6, 0)
// luceTestaColloTop.target.position.x = - 0.75
luceTestaColloTop.target.position.x =  0
luceTestaColloTop.target.position.z = 0
luceTestaColloTop.target.position.y = 1.2
// scene.add(luceTestaColloTop.target)
const luceTestaColloTopHelper = new THREE.SpotLightHelper(luceTestaColloTop)
// scene.add( luceTestaColloTopHelper)

// const luceTestaColloTop = new THREE.PointLight(0xff0000, 0.3, 15, 2)
// luceTestaColloTop.position.set(0, 1.29, 0)
// const luceTestaColloFrontHelper = new THREE.PointLightHelper(luceTestaColloFront, 0.2)


// BOTTOM

const luceTestaColloBottom = new THREE.SpotLight(0xff0000, 50, 0.5, Math.PI * 0.1, 0.1, 2)
luceTestaColloBottom.position.set(0,  0.7, 0.3)
// luceTestaColloBottom.target.position.x = - 0.75
luceTestaColloBottom.target.position.x =  0
luceTestaColloBottom.target.position.z = 0.1
luceTestaColloBottom.target.position.y = 0.99
// scene.add(luceTestaColloBottom.target)
const luceTestaColloBottomHelper = new THREE.SpotLightHelper(luceTestaColloBottom)
// scene.add( luceTestaColloBottomHelper)


//ANCA BACINO 
const ancaWidth = 0.5; 
const ancaHeight = 0.1;
const ancaIntensity = 15; 
// TOP
const luceAncaBacinoCenterTop = new THREE.RectAreaLight( 0xff0000, ancaIntensity, ancaWidth, ancaHeight ); 
luceAncaBacinoCenterTop.position.set( 0, 0.3, 0.135 ); 
luceAncaBacinoCenterTop.lookAt( 0, -2, -3.5 ); 
const luceAncaBacinoCenterTopHelper = new RectAreaLightHelper( luceAncaBacinoCenterTop ); 
// BOTTOM
const luceAncaBacinoCenterBottom = new THREE.RectAreaLight( 0xff0000, ancaIntensity, ancaWidth, ancaHeight ); 
luceAncaBacinoCenterBottom.position.set( 0, 0.1, 0.135 ); 
luceAncaBacinoCenterBottom.lookAt( 0, 2, -3.5); 
const luceAncaBacinoCenterBottomHelper = new RectAreaLightHelper( luceAncaBacinoCenterBottom ); 

// luceAncaBacinoCenterTop.add( luceAncaBacinoCenterTopHelper );
// luceAncaBacinoCenterBottom.add( luceAncaBacinoCenterBottomHelper );
// scene.add(luceAncaBacinoCenterBottom, luceAncaBacinoCenterTop)


// LUCE GINOCCHIO

const ginocchioWidth = 0.7; 
const ginocchioHeight = 0.09;
const ginocchioIntensity = 20; 
// TOP
const luceGinocchioCenterTop = new THREE.RectAreaLight( 0xff0000, ginocchioIntensity, ginocchioWidth, ginocchioHeight ); 
luceGinocchioCenterTop.position.set( 0, -0.3, 0.09 ); 
luceGinocchioCenterTop.lookAt( 0, -2, -3.5 ); 
// scene.add(luceGinocchioCenterTop)
const luceGinocchioCenterTopHelper = new RectAreaLightHelper( luceGinocchioCenterTop );
// scene.add(luceGinocchioCenterTopHelper) 
// BOTTOM
const luceGinocchioCenterBottom = new THREE.RectAreaLight( 0xff0000, ginocchioIntensity, ginocchioWidth, ginocchioHeight ); 
luceGinocchioCenterBottom.position.set( 0, -0.5, 0.05 ); 
luceGinocchioCenterBottom.lookAt( 0, 2, -3.5); 
// scene.add(luceGinocchioCenterBottom)

const luceGinocchioCenterBottomHelper = new RectAreaLightHelper( luceGinocchioCenterBottom );
// scene.add(luceGinocchioCenterBottomHelper) 


// CAVIGLIA PIEDE
const PiedeWidth = 1; 
const PiedeHeight = 1;
const PiedeIntensity = 15; 
// TOP
const lucePiede = new THREE.RectAreaLight( 0xff0000, PiedeIntensity, PiedeWidth, PiedeHeight ); 
lucePiede.position.set( 0, -0.80, 0.135 ); 
lucePiede.lookAt( 0, -0.9, 0.135 ); 
const lucePiedeHelper = new RectAreaLightHelper( lucePiede ); 
// scene.add(lucePiede, lucePiedeHelper)

// LUCI SCHIENA

// CENTER
const luceSchienaCenter = new THREE.PointLight(0xff0000, 0.2, 15, 2)
luceSchienaCenter.position.set( 0, 0.6, - 0.3)

// TOP
const luceSchienaTop = new THREE.PointLight(0xff0000, 0.2, 15, 2)
luceSchienaTop.position.set( 0, 0.9, - 0.3)

// BOTTOM
const luceSchienaBottom = new THREE.PointLight(0xff0000, 0.2, 15, 2)
luceSchienaBottom.position.set( 0, 0.3, - 0.3)




/**
 * Objects
*/
const gltfLoader = new GLTFLoader()
gltfLoader.load(
    './planet/scene.gltf', 
    (gltf) => {

        // Scale and position the model
        gltf.scene.scale.set(0.50, 0.50, 0.50);
        gltf.scene.position.set(0, -1, 0);

        // Traverse through the model and change the color of the materials
        gltf.scene.traverse((child) => {
            if (child.isMesh) {
                // Check if the material is a standard material
                if (child.material && child.material.isMeshStandardMaterial) {
                    child.material.color.set(0xc0bebe); // Change color to green (you can change this to any color)
                }
            }
        });
        // Add the model to the scene
        scene.add(gltf.scene);
    },
    undefined,
    (error) => {
        console.error('An error occurred while loading the GLTF model:', error);
    }
);


// MESH SPALLA SX
const spallaSinistraGeometry = new THREE.SphereGeometry(0.14, 16, 16 ); 
const spallaSinistraMaterial = new THREE.MeshBasicMaterial({ color: 0xff9000, visible: false});
const spallaSinistra = new THREE.Mesh(spallaSinistraGeometry, spallaSinistraMaterial);
spallaSinistra.position.set(0.2, 0.8, - 0.1)


// MESH SPALLA DX
const spallaDestraGeometry = new THREE.SphereGeometry(0.14, 16, 16 ); 
const spallaDestraMaterial = new THREE.MeshBasicMaterial({ color: 0xff9000, visible: false});
const spallaDestra = new THREE.Mesh(spallaDestraGeometry, spallaDestraMaterial);
spallaDestra.position.set(- 0.2, 0.8, - 0.1)

// MESH SPALLE
const spalla = new THREE.Group()
spalla.add(spallaSinistra, spallaDestra)
scene.add(spalla);

// MESH TESTA/COLLO
const testaColloGeometry = new THREE.SphereGeometry(0.16, 16, 16 ); 
const testaColloMaterial = new THREE.MeshBasicMaterial({ color: 0xff9000, visible: false});
const testaCollo = new THREE.Mesh(testaColloGeometry, testaColloMaterial);
testaCollo.position.y = 1.1
scene.add(testaCollo);

// MESH ANCA/BACINO
const ancaBacinoGeometry = new THREE.CylinderGeometry( 0.22, 0.22, 0.5, 10 ); 
const ancaBacinoMaterial =  new THREE.MeshBasicMaterial({ color: 0xff9000, visible: false});
const ancaBacino = new THREE.Mesh(ancaBacinoGeometry, ancaBacinoMaterial)
ancaBacino.position.y = 0.3
ancaBacino.position.z = 0.2
scene.add(ancaBacino)

// MESH GINOCCHIO 
const ginocchioGeometry = new THREE.CylinderGeometry( 0.20, 0.20, 0.5, 10);
const ginocchioMaterial =  new THREE.MeshBasicMaterial({ color: 0xff9000, visible: false});
const ginocchio = new THREE.Mesh(ginocchioGeometry, ginocchioMaterial)
ginocchio.rotation.z = 7.8
ginocchio.position.set(0, - 0.3, 0)
scene.add(ginocchio)

// MESH CAVIGLIA
const caviglieGeometry = new THREE.CylinderGeometry(0.25, 0.25, 0.55, 30); 
const cavigliaDestraMaterial = new THREE.MeshBasicMaterial({ color: 0xff9000, visible: false });
const cavigliaDestra = new THREE.Mesh(caviglieGeometry, cavigliaDestraMaterial);
cavigliaDestra.position.set(0, -1, 0);
cavigliaDestra.rotation.z = Math.PI * 0.50; 

// Add the cylinder mesh to the scene
scene.add(cavigliaDestra);

// MESH SCHIENA
const schienaGeometry = new THREE.PlaneGeometry( 0.4, 0.62 )
const schienaMaterial = new THREE.MeshBasicMaterial({ color: 0xff9000, visible: false});
const schiena = new THREE.Mesh(schienaGeometry, schienaMaterial)
schiena.rotation.y = Math.PI 
schiena.position.y = 0.59
schiena.position.z = -0.22

scene.add(schiena)




// Raycaster
const selectedCanvas = document.getElementById('canvasModel');
const mouse = new THREE.Vector2();
const raycaster = new THREE.Raycaster();

// Light state management
const lightStates = {
    // luceSpallaSx: false,
    // luceSpallaDx: false,
    spalle:false,
    luceTestaCollo: false,
    luceAncaBacino: false,
    luceGinocchio: false,
    lucePiedi: false,
    luceSchiena:false
};

function resetLightStates() {
    for (const key in lightStates) {
        if (lightStates.hasOwnProperty(key)) {
            lightStates[key] = false;
        }
    }
}

// Helper function to update mouse position relative to the canvas
function getRelativeMousePosition(event, element) {
    const rect = element.getBoundingClientRect(); // Get canvas position and size
    return {
        x: (event.clientX - rect.left) / rect.width,
        y: (event.clientY - rect.top) / rect.height,
    };
}

// Mouse move event
function onMouseMove(event) {
    const relativeMouse = getRelativeMousePosition(event, selectedCanvas);
    // Only proceed if mouse is inside the canvas bounds
    if (
        relativeMouse.x >= 0 && relativeMouse.x <= 1 &&
        relativeMouse.y >= 0 && relativeMouse.y <= 1
    ) {
        // Convert relative mouse position to normalized device coordinates (-1 to +1)
        mouse.x = relativeMouse.x * 2 - 1;
        mouse.y = -(relativeMouse.y * 2 - 1);

        // Update the raycaster with the camera and mouse position
        raycaster.setFromCamera(mouse, camera);

        // Check intersection for each part
        handleIntersection(spalla, 'spalle', luceSpallaDxCenter, luceSpallaDxBack, luceSpallaDxFront, luceSpallaSxCenter, luceSpallaSxBack, luceSpallaSxFront);
        handleIntersection(testaCollo, 'luceTestaCollo', luceTestaColloFront, luceTestaColloBack, luceTestaColloLeft, luceTestaColloRight, luceTestaColloBottom, luceTestaColloTop);
        handleIntersection(ancaBacino, 'luceAncaBacino', luceAncaBacinoCenterTop, luceAncaBacinoCenterBottom);
        handleIntersection(ginocchio, 'luceGinocchio', luceGinocchioCenterTop, luceGinocchioCenterBottom);
        handleIntersection(cavigliaDestra, 'lucePiedi', lucePiede);
        handleIntersection(schiena, 'luceSchiena', luceSchienaCenter, luceSchienaTop, luceSchienaBottom);

    }
}

// Generic function to handle intersections and toggle lights based on the state
function handleIntersection(object, lightKey, ...lights) {
    const intersects = raycaster.intersectObject(object);

    if (intersects.length > 0 || lightStates[lightKey]) {
        handleHovered(lightKey);
        lights.forEach(light => scene.add(light));
    } else {
        lights.forEach(light => scene.remove(light));
    }
}

// Mouse click event
function onMouseClick(event) {
    resetLightStates();
    const relativeMouseClick = getRelativeMousePosition(event, selectedCanvas);

    // Only proceed if mouse is inside the canvas bounds
    if (
        relativeMouseClick.x >= 0 && relativeMouseClick.x <= 1 &&
        relativeMouseClick.y >= 0 && relativeMouseClick.y <= 1
    ) {
        // Convert relative mouse position to normalized device coordinates (-1 to +1)
        mouse.x = relativeMouseClick.x * 2 - 1;
        mouse.y = -(relativeMouseClick.y * 2 - 1);

        // Update the raycaster with the camera and mouse position
        raycaster.setFromCamera(mouse, camera);

        // Toggle light state on click
        toggleLightOnObjectClick(spalla, 'spalle', luceSpallaDxCenter, luceSpallaDxBack, luceSpallaDxFront, luceSpallaSxCenter, luceSpallaSxBack, luceSpallaSxFront);
        toggleLightOnObjectClick(testaCollo, 'luceTestaCollo', luceTestaColloFront, luceTestaColloBack, luceTestaColloLeft, luceTestaColloRight, luceTestaColloTop);
        toggleLightOnObjectClick(ancaBacino, 'luceAncaBacino', luceAncaBacinoCenterTop, luceAncaBacinoCenterBottom);
        toggleLightOnObjectClick(ginocchio, 'luceGinocchio', luceGinocchioCenterTop, luceGinocchioCenterBottom);
        toggleLightOnObjectClick(cavigliaDestra, 'lucePiedi', lucePiede);
        toggleLightOnObjectClick(schiena, 'luceSchiena', luceSchienaCenter, luceSchienaTop, luceSchienaBottom);
    }
}

// Function to toggle lights based on click events
function toggleLightOnObjectClick(object, lightKey, ...lights) {
    const intersects = raycaster.intersectObject(object);

    if (intersects.length > 0) {
        handleSelectedSection(lightKey);
        lightStates[lightKey] = !lightStates[lightKey]; // Toggle light state
        if (lightStates[lightKey]) {
            lights.forEach(light => scene.add(light)); // Add lights
        } else {
            lights.forEach(light => scene.remove(light)); // Remove lights
        }
    }
}

window.addEventListener('mousemove', onMouseMove);
window.addEventListener('click', onMouseClick);

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth / 2.5,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth / 2.5
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(65, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.z = 2.25
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.enableZoom = false
controls.minPolarAngle = Math.PI/2 - 0.3;
controls.maxPolarAngle = Math.PI/2 - 0.3;


/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Pivot for Camera Rotation
 */
const pivot = new THREE.Object3D(); // Create a pivot point
scene.add(pivot); // Add the pivot to the scene
pivot.add(camera); // Add the camera to the pivot

// Set the initial position of the pivot (and camera relative to the pivot)
pivot.position.set(0, 0, 0); // Centered on the target object


/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime();

    pivot.rotation.y = - elapsedTime * 0.05; // Adjust the speed multiplier (0.1)

    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick();

}
export default HumanModelLogic;